import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { scrollBarStyle, astriskStyle } from 'src/styles/CommonStyles.styled';
import { ENVIRONMENTVARIABLE } from 'src/constants/appConstants';

export const HeadingShipAddress = styled.span`
    font-weight: 600;
    margin-right: 5px;
    margin-left: 7px;
`;

export const DistrictContainer = styled.div`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
`;
export const SurgeryDateViewAndNumberContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    padding-bottom: 1px;
    flex-direction: ${({ displayDirection }) =>
        displayDirection ? displayDirection : ''};
`;
export const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin: ${({ margin }) => (margin ? margin : '10px 0px 2px 0px')};
    padding: ${({ padding }) => (padding ? padding : '20px 15px')};
    position: relative;
    background: #ffffff 0% 0% no-repeat padding-box;
    width: cal(100%-20px);
    box-shadow: ${({ boxShadow }) =>
        boxShadow ? boxShadow : '0px 0px 6px #00000029'};
    border-radius: ${({ borderRadius }) =>
        borderRadius ? borderRadius : '6px'};
    ${media.mobileDevice`
        padding: ${({ padding }) => (padding ? padding : '20px 22px')};
        margin: ${({ mobileMargin }) => (mobileMargin ? mobileMargin : '')};
    `};
    // align-items:center;
`;

export const AutoCompleteContainer = styled.div`
    display: flex;
    flex-basis: 50%;
    width: 50%;
    width: ${({ width }) => (width ? width : '50%;')};
    .MuiBox-root {
        width: 100%;
    }
    .MuiAutocomplete-inputFocused {
        width: 100%;
    }
    .MuiAutocomplete-hasPopupIcon .MuiAutocomplete-inputRoot,
    .MuiAutocomplete-hasClearIcon .MuiAutocomplete-inputRoot {
        padding-right: 30px;
        font-size: 16px;
        font-family: 'AvenirNextWorld Regular';
    }
    .MuiAutocomplete-clearIndicator {
        padding: 4px;
        visibility: ${({ showClearIcon }) => showClearIcon};
        // margin-right: 10px !important;
    }
    .full-width-autocomplete {
        width: 100% !important;
        max-width: 100% !important;
    }
    .full-width-autocomplete .MuiInputBase-root {
        width: 100% !important;
        max-width: 100% !important;
    }
    ${media.mobileDevice`
        width:100%;
        margin-bottom: ${({ marginBottom }) =>
            marginBottom ? marginBottom : ''};
    `}
`;

export const FilterContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin: 10px 0px 2px 0px;
    padding: ${({ padding }) => (padding ? padding : '20px 24px')};
    position: relative;
    background: #ffffff 0% 0% no-repeat padding-box;
    width: cal(100%-20px);
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
    cursor: pointer;
    .accountList:focus {
        border: 1px solid #1010eb;
    }
    // align-items:center;
`;

export const AccountFilterList = styled.div`
    .accountList {
        display: flex;
        flex-direction: column;
        margin: 10px 0px 2px 0px;
        padding: ${({ padding }) => (padding ? padding : '20px 24px')};
        position: relative;
        background: #ffffff 0% 0% no-repeat padding-box;
        width: cal(100%-20px);
        box-shadow: 0px 0px 6px #00000029;
        border-radius: 6px;
        cursor: pointer;
    }
    .accountList:focus {
        border: 1px solid #1010eb;
    }
    // align-items:center;
`;

export const Title = styled.div`
    display: ${({ display }) => (display ? display : '')};
    align-items: baseline;
    font-family: AvenirNextWorld Demi;
    color: ${({ color }) => (color ? color : '#140F4B')};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '15px')};
    margin-bottom: ${({ marginBottom }) => (marginBottom ? '' : '8px')};
    cursor: ${({ isCursor }) => isCursor && 'pointer'};
    ${astriskStyle};
    ${media.mobileDevice`
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '14px')};
    color: ${({ color }) => (color ? color : '#202124')};
    `};
`;

export const RadioRowDiv = styled.span`
    display: inline-flex;
    width: ${({ width }) => (width ? width : '100%')};
    margin-bottom: ${({ marginBottom }) => marginBottom};
`;

export const ShippingContainer = styled.div`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    ${media.mobileDevice`
        margin-top: 16px;
    `}
`;

export const ShippingContainerSize = styled.div`
    flex-basis: ${({ flexBasis }) => (flexBasis ? flexBasis : '46%')};
    margin-bottom: ${({ marginBottom }) => marginBottom};
    ${media.mobileDevice`
    flex-basis: 100%;
    margin-bottom: ${({ marginBottom }) => marginBottom};
    margin-top: ${({ isReportReplenishment }) =>
        isReportReplenishment ? '-10px' : ''};
    `}
`;
export const SelectTemplate = styled.div`
    width: ${({ width }) => (width ? width : '100%')};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: ${({ whiteSpace }) => (whiteSpace ? whiteSpace : 'nowrap')};
    ${media.mobileDevice`
        /* width: ${({ mbWidth }) => (mbWidth ? mbWidth : '60%')}; */
    `}
`;

export const ModalSubmitButton = styled.div`
    display: flex;
    justify-content: flex-end;

    ${media.mediumDevice`
    position: fixed;
    width: 100%;
    bottom: 65px;
    right: 2px;
    margin: 0;
    padding: 5px;
    background-color: #ffffff;
    justify-content: flex-end;
    display: flex;
 `}

    ${media.exSmallDevice`
 bottom: 55px;
`}

${media.exSmallDevice`
bottom: 55px;
`}
`;

export const ShippingAddressContainer = styled.div`
    text-align: left;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
    padding: 15px 0px 0px 14px;
    border: ${({ showBorder }) => (showBorder ? '1px solid #1010EB' : '')};
`;

export const BackButton = styled.div`
    color: #1010eb;
    display: flex;
    cursor: pointer;
`;

export const BackIcon = styled.img`
    transform: rotate(90deg);
    cursor: pointer;
    ${media.mobileDevice`
        transform: rotate(90deg);
        height: 22px;
        width: 22px;
    `}
`;

export const BackText = styled.div`
    margin-top: 4px;
`;

export const BackButtonIcon = styled.div`
    margin-top: 5px;
`;

export const LookUpButton = styled.div`
    margin-top: 15px;
    ${media.mobileDevice`
    padding-left: 18px;
    padding-right: 17px;
    `}
`;

export const TotalCount = styled.div`
    color: #130e4a;
    padding: 10px 10px;
    font-size: 20px;
`;

export const SearchedItem = styled.span`
    font-weight: ${(props) => !props.phoneLable && '600'};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '20px')};
    font-family: ${(props) =>
        props.phoneLable ? 'AvenirNextWorld Regular' : 'AvenirNextWorld demi'};
`;

export const ShippingAddressContainerHeader = styled.div`
    font-size: 14px;
    font-family: AvenirNextWorld demi;
    color: #140f4b;
    font-weight: 600;
`;

export const ShippingAddressContainerSub = styled.span`
    color: #140f4b;
    margin-left: 5px;
    font-weight: 500;
`;

export const ShippingAddressContainerDetail = styled.span`
    font-size: 14px;
`;

export const AccountNameHeader = styled.div`
    color: #140f4b;
    font-family: 'AvenirNextWorld demi';
    font-size: 14px;
`;

export const AccountIdHeader = styled.span`
    color: ${({ color }) => (color ? color : '#140f4b')};
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Italic'};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '14px')};
`;

export const AdvanceSelectButton = styled.div`
    // position: fixed;
    // width: calc(100% - 38rem);
    // bottom: 11px;
    width: 100%;
    margin: ${({ margin }) => (margin ? margin : '0 0 0 0')};
    // right: 300px;
    padding: 5px;
    background-color: #ffffff;
    justify-content: flex-end;
    display: flex;

    ${media.mediumDevice`
    // position: fixed;
    width: 100%;
    bottom: 65px;
    right: 2px;
    margin: 0;
    padding: 5px;
    background-color: #ffffff;
    justify-content: flex-end;
    display: flex;
 `}
    ${media.mobileDevice`
 justify-content: center;
 margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '0px')};
 margin-right:${({ marginRight }) => (marginRight ? marginRight : '0px')};
`}
    ${media.exSmallDevice`
 bottom: 55px;
`}
`;
export const AlertMsg = styled.div`
    font-family: AvenirNextWorld Regular;
    color: red;
    font-size: 12px;
`;

export const AlertMsgShipToAccount = styled.div`
    font-family: AvenirNextWorld Italic;
    color: #040404;
    font-size: 14px;
    margin-top: 10px;
    margin-bottom: 100px;
    ${media.mobileDevice`
        margin-top: 29px;
        margin-left: 20px;
    `};
`;

export const ShipToCorousalDiv = styled.div`
    margin-top: 3px;
`;

export const LineSeparator = styled.hr`
    border: 1px solid #70707080;
    opacity: 0.3;
`;

export const HeaderDiv = styled.div`
    display: flex;
    justify-content: space-between;
    padding-top: ${({ paddingTop }) => (paddingTop ? paddingTop : '10px')};
    align-items: center;
    margin-bottom: ${(props) => props.marginBottom};
`;
export const HeaderTitle = styled.div`
    color: #130e4a;
    font-size: 18px;
    font-family: AvenirNextWorld Demi;
    ${media.mobileDevice`
    font-size: 20px;
    margin-left: ${(props) => props.mbMarginLeft};
    `};
`;
export const SelectShipToAddressContainer = styled.div`
    height: ${({ isIpad }) => (isIpad ? '43vh' : '61vh')};
    padding: 0px 10px;
    overflow-y: auto;
    overflow-x: hidden;
    ${scrollBarStyle}
    // ${media.mediumDevice`
    //     height: 43vh;
    // `};

    ${media.mobileDevice`
        height: 75vh;
        height: ${({ mbHeight }) => (mbHeight ? mbHeight : '75vh')};
    `};
    /* ${media.mobileDevice`
    margin-bottom: 9rem;
  //padding-bottom: ${({ paddingBottom }) =>
      ENVIRONMENTVARIABLE
          ? `max(${
                paddingBottom ? paddingBottom : '3vh'
            },calc(4*env(safe-area-inset-bottom)))`
          : paddingBottom
          ? paddingBottom
          : '10vh'};
`}; */
`;
export const CarousalContainer = styled.div`
    min-height: ${({ height }) => height};
    overflow-x: ${({ overflowX }) => overflowX};
    padding-left: 5px;
    margin-bottom: 10px;
`;
export const Icon = styled.img.attrs((props) => ({
    src: props.path,
}))`
    width: 22px;
    height: 23px;
    cursor: pointer;
`;

export const DetailsMainContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

export const MainContainerSecond = styled.div`
    display: flex;
    flex: ${({ flex }) => (flex ? flex : '50%')};
    flex-direction: column;
    position: relative;
    width: 100%;
    padding: 5px ${media.mobileDevice`
        padding: ${({ padding }) => (padding ? padding : '20px 22px')};
    `};
    margin-top: ${({ setMarginTop }) => (setMarginTop ? setMarginTop : '')};
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '')};

    // align-items:center;
    ${media.mobileDevice` 
        margin-bottom: ${({ marginBottom }) =>
            marginBottom ? marginBottom : ''};
        flex: ${({ flex, isPhysician }) => (isPhysician ? flex : '50%')};
    `};
`;

export const FlexDiv = styled.div`
    display: flex;
    justifycontent: space-around;
    flexdirection: row;
    width: 100%;
    ${media.mobileDevice`
        display:flex;
        flex-direction: column !important;
        justifyContent:space-around;
        width:100% ;
    `};
`;

export const MainContainerThird = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin: ${({ margin }) => (margin ? margin : '10px 0px 2px 0px')};
    padding: ${({ padding }) => (padding ? padding : '20px 15px')};
    position: relative;
    background: #ffffff 0% 0% no-repeat padding-box;
    width: 100%;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
    ${media.mobileDevice`
        padding: ${({ padding }) => (padding ? padding : '20px 22px')};
        flex-direction: column;
        margin: ${({ mobileMargin }) => (mobileMargin ? mobileMargin : '')};
        width: ${({ mobileWidth }) => (mobileWidth ? mobileWidth : '')};
    `};
    ${media.mobileDevice`
    flex-direction: column
`};
    // align-items:center;
`;

export const ImageContainer = styled.div`
    display: flex;
    margin-right: ${(props) =>
        props.marginRight ? props.marginRight : 'unset'};
    height: 27px;
    width: 25px;
    align-items: center;
    opacity: 1;
    justify-content: center;
    :active {
        box-shadow: -1px -1px 1px #cfe8fe;
    }
`;

export const OptionContainer = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin: 0;
    padding: 0;
    cursor: auto;
    padding: ${({ padding }) => (padding ? padding : '5px 10px')};
    & .template {
        font-size: 14px;
        color: #140f4b;
        font-family: AvenirNextWorld Regular;
    }
`;
